module.exports = __webpack_public_path__ + "img/25770a5.png";